import { type QueryHookOptions } from "@apollo/client";
import { useAttributesQuery } from "#graphql/supergraphHooks";
import { type AttributesQuery, type AttributesQueryVariables } from "#graphql/supergraphTypes";

/** A single Attribute as returned by the `attributes` query. */
export type Attribute = AttributesQuery["attributes"][number];

export interface UseAttributesReturn {
  attributes: Attribute[];
  loading: boolean;
  error: ReturnType<typeof useAttributesQuery>["error"];
  refetch: ReturnType<typeof useAttributesQuery>["refetch"];
}

/**
 * List attributes from the shared catalog, optionally filtered by `kind`
 * (`global_system` | `global_steward` | `space_local`). Reads `no-cache`,
 * matching the other Space/Attribute wrapper hooks.
 *
 * @example
 * const { attributes } = useAttributes({ kind: "global_steward" });
 */
export const useAttributes = (
  variables?: AttributesQueryVariables,
  options?: Omit<QueryHookOptions<AttributesQuery, AttributesQueryVariables>, "variables">,
): UseAttributesReturn => {
  const { data, loading, error, refetch } = useAttributesQuery({
    fetchPolicy: "no-cache",
    ...options,
    variables,
  });

  return {
    attributes: data?.attributes ?? [],
    loading,
    error,
    refetch,
  };
};
